import React from 'react';

const HTTPS_LINK = /https:\/\/[^\s<>"']+/gi;

export function parseLinkPreview(value) {
    if (!value) return null;
    let preview = value;
    if (typeof preview === 'string') {
        try {
            preview = JSON.parse(preview);
        } catch (error) {
            return null;
        }
    }
    if (!preview || typeof preview !== 'object') return null;
    const url = String(preview.url || '');
    if (!url.startsWith('https://')) return null;
    const image = String(preview.image || '');
    return {
        url,
        title: preview.title || '',
        description: preview.description || '',
        image: image.startsWith('https://') ? image : '',
        host: preview.host || '',
    };
}

function splitHttpsLinks(text) {
    const source = String(text || '');
    const parts = [];
    const pattern = new RegExp(HTTPS_LINK.source, 'gi');
    let last = 0;
    let match = pattern.exec(source);
    while (match) {
        if (match.index > last) {
            parts.push({ type: 'text', value: source.slice(last, match.index) });
        }
        const raw = match[0];
        const url = raw.replace(/[.,!?;:)]+$/, '');
        parts.push({ type: 'link', value: url });
        if (url.length < raw.length) {
            parts.push({ type: 'text', value: raw.slice(url.length) });
        }
        last = match.index + raw.length;
        match = pattern.exec(source);
    }
    if (last < source.length) {
        parts.push({ type: 'text', value: source.slice(last) });
    }
    return parts;
}

export default function ChatLinkText({ text, preview }) {
    const parts = splitHttpsLinks(text);
    const card = parseLinkPreview(preview);

    return (
        <div>
            <p className="mb-1" style={{ wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                {parts.map((part, index) => (
                    part.type === 'link' ? (
                        <a key={`${part.value}-${index}`} href={part.value} target="_blank" rel="noopener noreferrer">
                            {part.value}
                        </a>
                    ) : (
                        <span key={`text-${index}`}>{part.value}</span>
                    )
                ))}
            </p>
            {card ? (
                <a
                    href={card.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'block',
                        marginTop: 8,
                        maxWidth: 320,
                        borderRadius: 10,
                        overflow: 'hidden',
                        background: '#f3f4f4',
                        border: '1px solid #e2e4e4',
                        textDecoration: 'none',
                        color: 'inherit',
                    }}
                >
                    {card.image ? (
                        <img src={card.image} alt="" style={{ width: '100%', height: 150, objectFit: 'cover', display: 'block' }} />
                    ) : null}
                    <div style={{ padding: '8px 10px' }}>
                        {card.title ? <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 2 }}>{card.title}</div> : null}
                        {card.description ? (
                            <div style={{ fontSize: 12, color: '#5c5c5c', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                {card.description}
                            </div>
                        ) : null}
                        <div style={{ marginTop: 4, fontSize: 11, color: '#8a8a8a' }}>{card.host || card.url}</div>
                    </div>
                </a>
            ) : null}
        </div>
    );
}
